import { getConfiguration } from '../../init.js';
import { RenderingEngineModeEnum } from '../../enums/index.js';
export function isContextPoolRenderingEngine() {
    const config = getConfiguration();
    return (config?.rendering?.renderingEngineMode ===
        RenderingEngineModeEnum.ContextPool);
}
